import React, { useState, useEffect, Fragment, useContext } from "react";
import LayoutDashboard from "../../Components/Layout/LayoutDashboard";
import CssBaseline from "@material-ui/core/CssBaseline";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import AddIcon from "@material-ui/icons/Add";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import MaterialTable from "material-table";
import { Link } from "react-router-dom";
import AuthContext from "../../Context/autenticacion/authContext";
import {
  Button,
  Tooltip,
  Hidden,
  Grid,
  Box,
  Fab,
  Typography,
  IconButton,
} from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { green } from "@material-ui/core/colors";

import MethodGet, { MethodDelete } from "../../Config/Services";
/**Importar Sweetalert2 * */
import Swal from "sweetalert2";
/**importar spinner */
import Spinner from "../../Complements/Spinner";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: "100vh",
    overflow: "auto",
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingLeft: theme.spacing(11),
    paddingBottom: theme.spacing(4),
    //paddingInlineEnd: theme.spacing(2),
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    marginBlockEnd: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  input: {
    display: "none",
  },
  typography: {
    margin: theme.spacing(0, 1, 2, 2),
  },
  // Estilo de tablas Container
  titleTbl: {
    //backgroundColor:'#8115CF',
    background: "linear-gradient(50deg, #3f51b5 33%, indigo 100%)",
    color: "white",
    fontSize: "large",
    height: "60px",
    borderRadius: "5px",
    paddingTop: "10px",
    marginBottom: "20px",
    whiteSpace: "nowrap",
  },
  btnPlus: {
    display: "absolute",
    marginTop: "10%",
    marginRight: "-5%",
    zIndex: 2,
    position: "relative",
  },
  IconArrowBack: {
    paddingTop: "8px",
    marginRight: "-2%",
  },
  fabGreen: {
    color: theme.palette.common.white,
    backgroundColor: green[500],
    "&:hover": {
      backgroundColor: green[600],
    },
  },
}));

export default function ClientsSeller() {
  const classes = useStyles();
  //reglas negocio = state, guardarClient =funcion para guardar en el state;
  const [clients, guardarClient] = useState([]);
  const [cargando, spinnerCargando] = useState(false);

  //Extraer la informacion de autenticación
  const authContext = useContext(AuthContext);
  const { usuario, usuarioAutenticado, cerrarSesion } = authContext;
  useEffect(() => {
    usuarioAutenticado();
  }, []);

  //query a la api
  useEffect(() => {
    let url = "/clients";
    MethodGet(url)
      .then((res) => {
        guardarClient(res.data.data);
        spinnerCargando(true);
      })
      .catch((error) => {
        console.log(error);
        spinnerCargando(true);
      });
  }, []);

  // spinner de carga
  if (!cargando) return <Spinner />;

  return (
    <LayoutDashboard>
      {/* titulo */}
      <Grid container spacing={2}>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={12}
          style={{
            background: "linear-gradient(50deg, #3f51b5 33%, indigo 100%)",
            color: "white",
            borderRadius: 15,
            marginTop: 100,
            marginLeft: 25,
            marginRight: 25,
          }}
        >
          <Typography
            className={classes.typography}
            component="h1"
            variant="h4"
          >
            {"Mis Clientes en Sucursal"}
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={12}
          align="right"
          style={{ marginRight: 30, marginTop: -30 }}
        >
          {usuario ? (
            <Fab
              className={classes.fabGreen}
              aria-label="add"
              size="medium"
              href={"/Agregar_Cliente/" + usuario.id_branch_office}
            >
              <Tooltip title="Agregar Cliente" aria-label="Agregar Cliente">
                <AddIcon size="large" />
              </Tooltip>
            </Fab>
          ) : null}
        </Grid>
      </Grid>
      {/**
       * Se renderiza el titulo y los botones de las vista de tabla asi como el ajuste de mobile *-
       *
       */}
      <Hidden only={["xs", "sm"]}>
        <Grid Container spacing={3} style={{paddingLeft:20,paddingRight:20, marginTop: 10 }}>
          <MaterialTable
            title=""
            columns={[
              { title: "Nombre Completo", field: "full_name" },
              { title: "Teléfono", field: "number_phone" },
              { title: "Calle", field: "street" },
              {
                title: "#Ext",
                field: "number_ext",
                render: (rowData) =>
                  rowData.number_ext ? (
                    <p> {rowData.number_ext} </p>
                  ) : (
                    <p> S/N </p>
                  ),
              },
              {
                title: "#Int",
                field: "number_int",
                render: (rowData) =>
                  rowData.number_int ? (
                    <p> {rowData.number_int} </p>
                  ) : (
                    <p> S/N </p>
                  ),
              },
              { title: "C.P", field: "postal_code" },
              {
                title: "RFC",
                field: "RFC",
                render: (rowData) =>
                  rowData.RFC ? <p> {rowData.RFC} </p> : <p> No registrado </p>,
              },
            ]}
            data={clients}
            options={{
              headerStyle: {
                backgroundColor: "none",
                color: "#000",
                fontSize: "16px",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                overflow: "hidden",
              },

              actionsColumnIndex: -1,
            }}
            actions={[
              (rowData) => ({
                icon: "delete",
                tooltip: "Eliminar cliente",
              }),
            ]}
            components={{
              Action: (props) => (
                <Fragment>
                  <Link
                    to={`Editar_Cliente/${props.data.id}`}
                    style={{ color: "#3f51b5" }}
                  >
                    <Button
                      variant="contained"
                      style={{
                        textTransform: "none",
                        background: "white",
                      }}
                      size="small"
                    >
                      <Tooltip
                        title="Editar Cliente"
                        aria-label="Editar Cliente"
                      >
                        <EditIcon style={{ color: "blue" }} />
                      </Tooltip>
                    </Button>
                  </Link>
                </Fragment>
              ),
            }}
            localization={{
              pagination: {
                labelDisplayedRows: "{from}-{to} de {count}",
                labelRowsSelect: "Columnas",
                firstTooltip: "Primera Página",
                previousTooltip: "Anterior",
                nextTooltip: "Siguiente",
                lastTooltip: "Ultíma Página",
              },
              toolbar: {
                searchTooltip: "Buscar ",
                searchPlaceholder: "Buscar",
              },
              header: {
                actions: "Opciones",
              },
              body: {
                emptyDataSourceMessage: "No hay Clientes que Mostrar",
                filterRow: {
                  filterTooltip: "Buscar",
                },
              },
            }}
          />
        </Grid>
      </Hidden>
      <Hidden only={["md", "lg", "xl"]}>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={12}
          style={{ marginTop: 10 }}
        >
          <MaterialTable
            title={""}
            columns={[
              { title: "Nombre Completo", field: "full_name" },
              { title: "Teléfono", field: "number_phone" },
            ]}
            data={clients}
            options={{
              headerStyle: {
                backgroundColor: "none",
                color: "#000",
                fontSize: "16px",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                overflow: "hidden",
              },

              actionsColumnIndex: -1,
            }}
            detailPanel={[
              {
                tooltip: "Show",
                render: (rowData) => {
                  return (
                    <div
                      style={{
                        color: "black",
                        marginLeft: 50,
                      }}
                    >
                      <p>Calle: {rowData.street}</p>
                      <p>
                        #Ext:{" "}
                        {rowData.number_ext ? (
                          <> {rowData.number_ext} </>
                        ) : (
                          <> S/N </>
                        )}
                      </p>
                      <p>
                        #Int:{" "}
                        {rowData.number_int ? (
                          <> {rowData.number_int} </>
                        ) : (
                          <> S/N </>
                        )}
                      </p>
                      <p>C.P: {rowData.postal_code}</p>
                      <p>
                        RFC:{" "}
                        {rowData.RFC ? (
                          <> {rowData.RFC} </>
                        ) : (
                          <> No registrado </>
                        )}
                      </p>
                      <p>Opciones: </p>
                      <p>
                        {
                          <Fragment>
                            <Link
                              to={`Editar_Cliente/${rowData.id}`}
                              style={{ color: "#3f51b5" }}
                            >
                              <IconButton
                                variant="contained"
                                style={{
                                  textTransform: "none",
                                  background: "white",
                                  marginLeft: 60,
                                }}
                                size="small"
                              >
                                <Tooltip
                                  title="Editar Cliente"
                                  aria-label="Editar Cliente"
                                >
                                  <EditIcon style={{ color: "blue" }} />
                                </Tooltip>
                              </IconButton>
                            </Link>
                          </Fragment>
                        }
                      </p>
                    </div>
                  );
                },
              },
            ]}
            localization={{
              pagination: {
                labelDisplayedRows: "{from}-{to} de {count}",
                labelRowsSelect: "Columnas",
                firstTooltip: "Primera Página",
                previousTooltip: "Anterior",
                nextTooltip: "Siguiente",
                lastTooltip: "Ultíma Página",
              },
              toolbar: {
                searchTooltip: "Buscar ",
                searchPlaceholder: "Buscar",
              },
              header: {
                actions: "Opciones",
              },
              body: {
                emptyDataSourceMessage: "No hay Clientes que Mostrar",
                filterRow: {
                  filterTooltip: "Buscar",
                },
              },
            }}
          />
        </Grid>
      </Hidden>
    </LayoutDashboard>
  );
}
